@if (audit) {
    <div class="desktop-container" [ngClass]="{'last': isLast}">
        <div>
            <span class="intro">
                <div>
                    <h3 class="p-0 m-0">{{ title }}</h3>
                    <div class="flex items-center gap-2">
                        <p>Due Date <b>{{ dueDateLabel }}.</b></p>
                        <p>Status: <b>{{ status }}</b></p>
                    </div>
                </div>
            </span>
        </div>
        <div class="form-type type-audit">
            Internal Audit
        </div>
        <div class="flex justify-content-end flex-nowrap gap-3">
            <a
                class="btn-secondary"
                [routerLink]="['/assurance/internal-audit', audit._id]"
                (click)="$event.stopPropagation()">
                View
            </a>
        </div>
    </div>

    <div class="mobile-container" (click)="$event.stopPropagation()">
        <app-flight-card-mobile [content]="'flex'">
            <ng-container title>{{ title }}</ng-container>
            <ng-container subtitle>
                <div class="form-type type-audit mt-2">Internal Audit</div>
            </ng-container>
            <ng-container content>
                <div class="data-field">
                    <span>Due Date: <span class="font-bold">{{ dueDateLabel }}</span></span>
                </div>
                <div class="data-field">
                    <span>Status: <span class="font-bold">{{ status }}</span></span>
                </div>
            </ng-container>
            <ng-container actions>
                <a
                    class="btn-secondary w-full"
                    [routerLink]="['/assurance/internal-audit', audit._id]"
                    (click)="$event.stopPropagation()">
                    View
                </a>
            </ng-container>
        </app-flight-card-mobile>
    </div>
}
